import { CircularProgress } from "@mui/material";
import React from "react";

const SetValueButton = ({
	onClick,
	children,
	title,
	style,
	disabled,
	isUpdating = false,
}) => {
	return (
		<button
			type="button"
			style={{
				background: "#D6EEFF",
				color: "#7F7F7F",
				border: "none",
				cursor: disabled || isUpdating ? "not-allowed" : "pointer",
				width: "100%",
				padding: "4px 4px",
				opacity: disabled || isUpdating ? 0.6 : 1,
				fontSize: "11px",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				...style,
			}}
			title={title ? title : children}
			onClick={onClick}
			disabled={disabled || isUpdating}
		>
			{isUpdating ? <CircularProgress size="10px" /> : children}
		</button>
	);
};

export default SetValueButton;
